<template>
    <div>

        <!-- Table -->

        <enac-custom-atpl-resource-links-table :id="id" :endpoint="endpoint" :endpoint-params="endpointParams"
            :bus="bus" :editing="contextId" :learning-unit-id="learningUnitId">
        </enac-custom-atpl-resource-links-table>

        <!-- Creation button -->

        <div class="text-center mt-3" v-if="contextId">
            <button class="btn btn-round btn-default" @click="newLink">
                {{ lang.polaris.form.add_link }}
            </button>
        </div>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus" :title="lang.polaris.form.add_link">
            <enac-custom-atpl-resource-links-form :id="id" :bus="bus" :endpoint="endpoint">
            </enac-custom-atpl-resource-links-form>
        </trax-ui-modal-default>

        <!-- Deletion confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="lang.polaris.form.link_deletion" :bus="bus">
            {{ lang.polaris.form.confirm_delete_q }}
        </trax-ui-modal-confirm>

        <!-- Local toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1">
        </trax-ui-toastr>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: { default: 'enac-custom-links' },
            learningUnitId: null,
            contextId: null,
        },

        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/resources',
                endpointParams: {
                    filters: { learning_unit_id: this.learningUnitId },
                    sort: ['name']
                },
                bus: new Vue()
            }
        },

        methods: {

            newLink: function() {
                this.bus.$emit(this.id+'-edit-open');
            }
        }
    }
</script>
